import axios, { AxiosError, AxiosInstance } from 'axios'
import { notification } from 'antd'

function generateBearerToken(token: string) {
    return `Bearer ${token}`
}

class API {
    private axiosInstance: AxiosInstance

    constructor() {
        const accessToken = localStorage.getItem('access_token')

        const headers = accessToken
            ? {
                  Authorization: generateBearerToken(accessToken),
              }
            : {}

        this.axiosInstance = axios.create({
            baseURL: `${process.env.REACT_APP_API}/api`,
            headers,
        })

        this.axiosInstance.interceptors.response.use(
            function (response) {
                return response
            },
            function (error: AxiosError) {
                // @ts-ignore
                const { response: { data: { code, sqlMessage, message } = {} } = {} } = error
                notification.error({
                    message: 'Error',
                    description: `Code: ${code}. Sql message: ${sqlMessage}. Message: ${
                        Array.isArray(message) ? message.join('. ') : message
                    }`,
                })

                return Promise.reject(error)
            }
        )
    }

    setAccessToken(accessToken: string) {
        this.axiosInstance.defaults.headers.common['Authorization'] = generateBearerToken(accessToken)
    }

    removeAccessToken() {
        delete this.axiosInstance.defaults.headers['Authorization']
    }

    async get<ResponseType>(endpoint: string) {
        return this.axiosInstance.get(endpoint).then(({ data }) => data as ResponseType)
    }

    async post<RequestType = unknown, ResponseType = RequestType>(endpoint: string, body?: RequestType) {
        return this.axiosInstance.post(endpoint, body).then(({ data }) => data as ResponseType)
    }

    async put<RequestType = unknown, ResponseType = RequestType>(endpoint: string, body: RequestType) {
        return this.axiosInstance.put(endpoint, body).then(({ data }) => data as ResponseType)
    }

    async patch<RequestType = unknown, ResponseType = RequestType>(endpoint: string, body: RequestType) {
        return this.axiosInstance.patch(endpoint, body).then(({ data }) => data as ResponseType)
    }

    async delete<ResponseType>(endpoint: string) {
        return this.axiosInstance.delete(endpoint).then(({ data }) => data as ResponseType)
    }
}

export const apiClient = new API()
